import { PPApiService } from '@openeducation/pp-rn-services';
import type { ExpiredLinkInfo } from '@openeducation/pp-rn-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';
import { QueryKey } from '../../types';

interface UseGetExpiredLinkInfoInput {
  sfdcToken: string;
}

export const useGetExpiredLinkInfo = (
  { sfdcToken }: UseGetExpiredLinkInfoInput,
  enabled = true
) => {
  const { environment } = useEnvironmentContext();

  const { data, isError, isLoading } = useQuery<ExpiredLinkInfo>(
    [QueryKey.GetExpiredLinkInfo, sfdcToken],
    () => PPApiService.getExpiredLinkInfo(environment, sfdcToken),
    { enabled: enabled && !!sfdcToken, retry: false }
  );

  return {
    data,
    isError,
    isLoading,
  };
};
